import type { PromotionLineItem } from '@weft/types';
import React from 'react';
import { DynamicInvoicePromotionLineItem } from '../DynamicInvoicePromotionLineItem';
import { DynamicInvoiceViewSection } from '../DynamicInvoiceViewSection';

type PromotionLineItemsSectionProps = {
  promotionLineItems: PromotionLineItem[];
};

export const PromotionLineItemsSection: React.FC<PromotionLineItemsSectionProps> = ({ promotionLineItems }) => {
  return (
    <DynamicInvoiceViewSection
      title="Promotions"
    >
      {promotionLineItems.map((lineItem) => (
        <DynamicInvoicePromotionLineItem
          key={lineItem.id}
          promotionLineItem={lineItem}
        />
      ))}
    </DynamicInvoiceViewSection>
  );
};